import directive from './directives';

const importDirective = Vue => {
    /**
     * 自动获取焦点指令 v-longpress
     */
    Vue.directive('longpress', directive.longpress);
};

export default importDirective;



// WEBPACK FOOTER //
// ./src/directive/index.js